module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Bold.a64a8504.ttf";